var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.loading}}),(!_vm.error)?_c('h2',[_vm._v("Okyanus Web Service")]):_vm._e(),(_vm.error)?_c('SsoError',{attrs:{"message":_vm.error}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }